var _path, _path2, _path3, _path4, _path5, _path6, _path7, _text, _text2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgJson = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 41.8 57.333"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 21424",
  d: "M1.4 0A1.367 1.367 0 0 0 0 1.4v48.7a1.367 1.367 0 0 0 1.4 1.4h39a1.367 1.367 0 0 0 1.4-1.4V16.7a3.69 3.69 0 0 0-1-2.4L27.3 1a4.286 4.286 0 0 0-2.4-1Z",
  fill: "gray"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 21425",
  d: "M2.5.9a1.367 1.367 0 0 0-1.4 1.4v47.3A1.367 1.367 0 0 0 2.5 51h37.3a1.367 1.367 0 0 0 1.4-1.4V17a3.69 3.69 0 0 0-1-2.4L27.6 1.9a4.286 4.286 0 0 0-2.4-1Z",
  fill: "#fff"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 21426",
  d: "M27.3 4.6v6.9a2.582 2.582 0 0 0 2.6 2.6h7.2Z",
  fill: "#eaecef"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 21427",
  d: "m26.8 13.1-.6-11.4-1 13a1.367 1.367 0 0 0 1.4 1.4h12.5l-11-1.6a1.347 1.347 0 0 1-1.3-1.4Z",
  fill: "#e6e7e8"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 21428",
  d: "M41.2 37.1a1.216 1.216 0 0 1-1.2 1.2H2.4a1.155 1.155 0 0 1-1.2-1.2v-14a1.216 1.216 0 0 1 1.2-1.2H40a1.155 1.155 0 0 1 1.2 1.2Z",
  fill: "#413a8e"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 21429",
  d: "M41.2 37.8A1.216 1.216 0 0 1 40 39H2.4a1.155 1.155 0 0 1-1.2-1.2v-14a1.216 1.216 0 0 1 1.2-1.2H40a1.155 1.155 0 0 1 1.2 1.2Z",
  fill: "#6558bf"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 21430",
  d: "M24.1 47v-6.1h-6.4V47h-3.3l6.4 8 6.5-8Z",
  fill: "#6558bf",
  stroke: "#fff",
  strokeWidth: 2.928
})), _text || (_text = /*#__PURE__*/React.createElement("text", {
  "data-name": "JSON",
  transform: "translate(5.376 35.136)",
  fill: "#fff",
  fontSize: 12.68,
  fontFamily: "Nunito Sans"
}, /*#__PURE__*/React.createElement("tspan", {
  x: 0,
  y: 0
}, "JSON"))), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
  "data-name": "JSON",
  transform: "translate(5.376 35.136)",
  fill: "none",
  stroke: "#fff",
  strokeWidth: 0.244,
  fontSize: 12.68,
  fontFamily: "Nunito Sans"
}, /*#__PURE__*/React.createElement("tspan", {
  x: 0,
  y: 0
}, "JSON"))));
export default SvgJson;